import { render } from "./CountryBadges.vue?vue&type=template&id=ed578dce&scoped=true"
import script from "./CountryBadges.vue?vue&type=script&lang=js"
export * from "./CountryBadges.vue?vue&type=script&lang=js"

import "./CountryBadges.vue?vue&type=style&index=0&id=ed578dce&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed578dce"]])

export default __exports__